import { SortFieldDisplayProps, SortingOptionsType } from '@components/design/migrated/Table';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { DefaultSortingOptionsForCategoryLeaderboard } from '@models/CategoryLeaderboard';
import { OpaSubscription } from '@models/Opa';
import { DefaultSortingOptionsForOpportunityReview } from '@models/OpportunityReview';
import { DefaultSortingOptionsForProducts } from '@models/Products';
import { PagesConfig, PagesConfigContext } from './PagesConfigContext';
import {
  AllSavedFilters,
  Country,
  CountryFilterPair,
  CountryMasterPgsFilterPair,
  Filters,
  Option,
  PageName,
  PageType,
  ProductGroupFeatureValue,
  ProductGroupPriceBandValue,
  ProductGroups,
  SavedFilters,
  SelectedFilters,
} from './Types';
import {
  DefaultSortByOptionsForPerformanceAnalysisStackedChart,
  DefaultSortingOptionsForPerformanceAnalysisboard,
} from '@models/PerformanceAnalysisboard';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { CurrencyExchangeRatePerCountry } from '@services/Types';

const PagesConfigProvider: React.FC = ({ children }) => {
  const sideFiltersState = useSelector((state: any) => state.sideFilters);

  const [clientId, changeClientId] = useState<number>(-1); //NOSONAR typescript:S6754
  // prettier-ignore
  const [clientSubscription, changeClientSubscription] = useState<OpaSubscription>({ //NOSONAR typescript:S6754
        result: {access: 'restricted', restrictions: []},
    });
  const [clientCountries, changeClientCountries] = useState<Country[]>([]); //NOSONAR typescript:S6754
  const [userId, updateUserId] = useState<string>(''); //NOSONAR typescript:S6754
  const [filtersTrayOpened, setFiltersTray] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [pageType, setNewPageType] = useState<PageType>(PageType.RETAILER_OVERVIEW); //NOSONAR typescript:S6754
  const [pageName, setNewPageName] = useState<PageName>(PageName.RETAILER_OVERVIEW); //NOSONAR typescript:S6754
  const [selectedPgUpdated, updateSelectedPgUpdated] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [selectedFilters, updateSelectedFilters] = useState<SelectedFilters[]>(sideFiltersState.appliedFilters); //NOSONAR typescript:S6754
  const [appliedFilters, updateAppliedFilters] = useState<SelectedFilters[]>(sideFiltersState.appliedFilters); //NOSONAR typescript:S6754
  const [pgsByPage, updatePGsByPage] = useState<ProductGroups[]>(sideFiltersState.pgsByPage); //NOSONAR typescript:S6754
  const [pgsByCountry, updatePGsByCountry] = useState<CountryFilterPair[]>(sideFiltersState.pgsByCountry ?? []); //NOSONAR typescript:S6754
  const [currencyExchangeRatePerCountry, setCurrencyExchangeRatePerCountry] = useState<
    CurrencyExchangeRatePerCountry[]
  >([]);
  const [masterPgsByCountry, updateMasterPgsByCountry] = useState<CountryMasterPgsFilterPair[]>([]); //NOSONAR typescript:S6754
  const [pgsByAppliedCountry, updatePGsByAppliedCountry] = useState<CountryFilterPair[]>( //NOSONAR typescript:S6754
    sideFiltersState.pgsByAppliedCountry ?? [],
  );
  const [clearFilters, toggleClearFilters] = useState<boolean>(true); //NOSONAR typescript:S6754
  const [applyFilters, toggleApplyFilters] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [addFeatures, updateAddFeatures] = useState<Filters[] | undefined>(undefined); //NOSONAR typescript:S6754
  const [segFeatures, updateSegFeatures] = useState<Filters[] | undefined>(undefined); //NOSONAR typescript:S6754
  const [sortingOptions, updateSortOptions] = useState<SortingOptionsType>(DefaultSortingOptionsForCategoryLeaderboard); //NOSONAR typescript:S6754
  const [selectedTimeFrame, updateSelectedTimeFrame] = useState<Periodicity | undefined>(undefined); //NOSONAR typescript:S6754
  const [selectedTimePeriod, updateSelectedTimePeriod] = useState<BaseTimePeriod | undefined>(undefined); //NOSONAR typescript:S6754
  const [isNavigateFromCategoryLeaderboard, updateNavigateFromCategoryLeaderboard] = useState<boolean>(false); //NOSONAR typescript:S6754

  const [pgListUpdated, updatedPgListUpdated] = useState<boolean>(false); //NOSONAR typescript:S6754
  // prettier-ignore
  const [savedFilters, updateSavedFilters] = useState<AllSavedFilters[]>([ //NOSONAR typescript:S6754
        {pageType: PageType.CATEGORY_LEADERBOARD, savedFilters: []},
        {pageType: PageType.RETAILER_OVERVIEW, savedFilters: []},
        {pageType: PageType.OPPORTUNITY_REVIEW, savedFilters: []},
        {pageType: PageType.TRADING_ASSISTANT, savedFilters: []},
        {pageType: PageType.PERFORMANCE_ANALYSIS, savedFilters: []},
        {pageType: PageType.RI_PRODUCT, savedFilters: []},
        {pageType: PageType.EXPLORE, savedFilters: []},
    ]);
  const [isNavigateFromRS, updateIsNavigateFromRS] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [isNavigateFromOpportunity, updateIsNavigateFromOpportunity] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [isFirstVisit, updateIsFirstVisit] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [isCountryChanged, updateIsCountryChanged] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [isMultiCountryDropdown, updateIsMultiCountryDropdown] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [sortingOptionsOpportunityReview, updateSortOptionsOpportunityReview] = useState<SortingOptionsType>( //NOSONAR typescript:S6754
    DefaultSortingOptionsForOpportunityReview,
  );
  const [sortingOptionsPerformanceAnalysisStackedChart, updateSortOptionsPerformanceAnalysisStackedChart] = //NOSONAR typescript:S6754
    useState<SortingOptionsType>(DefaultSortingOptionsForPerformanceAnalysisboard);
  const [isNavigateFromPerfAnalysis, updateIsNavigateFromPerfAnalysis] = useState<boolean>(false); //NOSONAR typescript:S6754
  const [isTimePeriodFirstLoad, updateIsTimePeriodFirstLoad] = useState<boolean>(true); //NOSONAR typescript:S6754
  const [sortByOptionsPerformanceAnalysisStackedChart, setSortByOptionsPerformanceAnalysisStackedChart] =
    useState<SortFieldDisplayProps>(DefaultSortByOptionsForPerformanceAnalysisStackedChart);
  const [isRetailerChanged, updateIsRetailerChanged] = useState<boolean>(false); //NOSONAR typescript:S6754

  const [hitlistsClientId, changeHitlistsClientId] = useState<number>(-1); //NOSONAR typescript:S6754
  // prettier-ignore
  const [hitlistsClientSubscription, changeHitlistsClientSubscription] = useState<OpaSubscription>({ //NOSONAR typescript:S6754
        result: {access: 'restricted', restrictions: []},
    });
  const [hitlistsClientCountries, changeHitlistsClientCountries] = useState<Country[]>([]); //NOSONAR typescript:S6754

  const [retailKadClientId, changeRetailKadClientId] = useState<number>(-1); //NOSONAR typescript:S6754
  // prettier-ignore
  const [retailKadClientSubscription, changeRetailKadClientSubscription] = useState<OpaSubscription>({ //NOSONAR typescript:S6754
        result: {access: 'restricted', restrictions: []},
    });
  const [retailKadClientCountries, changeRetailKadClientCountries] = useState<Country[]>([]); //NOSONAR typescript:S6754
  const [marketPremiumClientId, changeMarketPremiumClientId] = useState<number>(-1); //NOSONAR typescript:S6754
  // prettier-ignore
  const [marketPremiumClientSubscription, changeMarketPremiumClientSubscription] = useState<OpaSubscription>({ //NOSONAR typescript:S6754
        result: {access: 'restricted', restrictions: []},
    });

  const [marketPremiumClientCountries, changeMarketPremiumClientCountries] = useState<Country[]>([]); //NOSONAR typescript:S6754
  const [sellerInsightsClientId, changeSellerInsightsClientId] = useState<number>(-1); //NOSONAR typescript:S6754
  // prettier-ignore
  const [sellerInsightsClientSubscription, changeSellerInsightsClientSubscription] = useState<OpaSubscription>({ //NOSONAR typescript:S6754
        result: {access: 'restricted', restrictions: []},
    });
  const [sellerInsightsClientCountries, changeSellerInsightsClientCountries] = useState<Country[]>([]); //NOSONAR typescript:S6754

  const [productGroupFeatureValueList, updateProductGroupFeatureValueList] = useState<ProductGroupFeatureValue[]>([]); //NOSONAR typescript:S6754

  const [productGroupPriceBandValueList, updateProductGroupPriceBandValueList] = useState<ProductGroupPriceBandValue[]>( //NOSONAR typescript:S6754
    [],
  );

  const [savedFilterCountryList, updateSavedFilterCountryList] = useState<string[]>([]); //NOSONAR typescript:S6754

  // prettier-ignore
  const [savedFilterToShare, updateSavedFilterToShare] = useState<SavedFilters>({//NOSONAR typescript:S6754
        id: '1',
        name: '',
        filters: [],
        permissions: [],
        namespace: '',
        createdAt: new Date().getTime(),
        clientId: 1,
        country: '',
        periodicity: Periodicity.Monthly,
    });

  const [isMultiCountryFeatureFlagPA, setIsMultiCountryFeatureFlagPA] = useState<boolean>(false);

  const [isSideFiltersFeatureFlagEnabled, setIsSideFiltersFeatureFlagEnabled] = useState<boolean>(false);

  const [multiCountryClientCountries, changeMultiCountryClientCountries] = useState<Option[]>([]); //NOSONAR typescript:S6754

  const [isClearAllFilterTriggered, setIsClearAllFilterTriggered] = useState<boolean>(false);

  const [access, changeAccess] = useState<Object>({} as Object); //NOSONAR typescript:S6754
  const [isHidePGInfoWarning, setIsHidePGInfoWarning] = useState<boolean>(false);
  const [isAllPgsByPeriodicityAvailable, setIsAllPgsByPeriodicityAvailable] = useState<boolean>(false);

  const updateIsMultiCountryFeatureFlagPA = (featureFlagEnabled: boolean) => {
    setIsMultiCountryFeatureFlagPA(featureFlagEnabled);
  };

  const updateIsSideFiltersFeatureFlag = (featureFlagEnabled: boolean) => {
    setIsSideFiltersFeatureFlagEnabled(featureFlagEnabled);
  };

  const setClientId = (id: number) => {
    changeClientId(id);
  };

  const setClientSubscription = (subscription: OpaSubscription) => {
    changeClientSubscription(subscription);
  };

  const setClientCountries = (countryList: Country[]) => {
    changeClientCountries(countryList);
  };

  const setUserId = (id: string) => {
    updateUserId(id);
  };

  const toggleFiltersTray = (isOpen: boolean) => {
    setFiltersTray(isOpen);
  };

  const setPageType = (newPageType: PageType) => {
    setNewPageType(newPageType);
  };

  const setPageName = (newPageName: PageName) => {
    setNewPageName(newPageName);
  };

  const getPageTypeAndName = () => ({
    pageType,
    pageName,
  });

  const setSelectedPgUpdated = (isUpdated: boolean) => {
    updateSelectedPgUpdated(isUpdated);
  };

  const setSelectedFilters = (newSelectedFilters: SelectedFilters[]) => {
    updateSelectedFilters(newSelectedFilters);
  };

  const setAppliedFilters = (newAppliedFilters: SelectedFilters[]) => {
    updateAppliedFilters(newAppliedFilters);
  };

  const setPgsByPage = (newPGsByPage: ProductGroups[]) => {
    updatePGsByPage(newPGsByPage);
  };

  const updateCurrencyExchangeRatePerCountry = (exchangeRate: CurrencyExchangeRatePerCountry[]) => {
    setCurrencyExchangeRatePerCountry(exchangeRate);
  };

  const setPGsByCountry = (newPGsByCountry: CountryFilterPair[]) => {
    updatePGsByCountry(newPGsByCountry);
  };
  const setMasterPgsByCountry = (newMasterPgsByCountry: CountryMasterPgsFilterPair[]) => {
    updateMasterPgsByCountry(newMasterPgsByCountry);
  };
  const setPGsByAppliedCountry = (newPGsByAppliedCountry: CountryFilterPair[]) => {
    updatePGsByAppliedCountry(newPGsByAppliedCountry);
  };

  const setClearFilters = (clear: boolean) => {
    toggleClearFilters(clear);
  };

  const setApplyFilters = (apply: boolean) => {
    toggleApplyFilters(apply);
  };

  const setAddFeatures = (filters: Filters[]) => {
    updateAddFeatures(filters);
  };

  const setSegFeatures = (filters: Filters[]) => {
    updateSegFeatures(filters);
  };

  const setSortingOptions = (options: SortingOptionsType) => {
    updateSortOptions(options);
  };

  const setSelectedTimeFrame = (timeFrame: Periodicity) => {
    updateSelectedTimeFrame(timeFrame);
  };

  const setSelectedTimePeriod = (timePeriod: BaseTimePeriod) => {
    updateSelectedTimePeriod(timePeriod);
  };

  const setNavigateFromCategoryLeaderboard = (navigateFromCategoryLeaderboard: boolean) => {
    updateNavigateFromCategoryLeaderboard(navigateFromCategoryLeaderboard);
  };

  const setPgListUpdated = (updated: boolean) => {
    updatedPgListUpdated(updated);
  };

  const setSavedFilters = (updated: any) => {
    updateSavedFilters(updated);
  };

  const setIsNavigateFromRS = (updated: any) => {
    updateIsNavigateFromRS(updated);
  };

  const setIsNavigateFromOpportunity = (navigateFromOpportunity: boolean) => {
    updateIsNavigateFromOpportunity(navigateFromOpportunity);
  };

  const setIsFirstVisit = (firstVisit: boolean) => {
    updateIsFirstVisit(firstVisit);
  };

  const setIsCountryChanged = (changed: boolean) => {
    updateIsCountryChanged(changed);
  };

  const setSortingOptionsOpportunityReview = (options: SortingOptionsType) => {
    updateSortOptionsOpportunityReview(options);
  };

  const setSortingOptionsPerformanceAnalysisStackedChart = (options: SortingOptionsType) => {
    updateSortOptionsPerformanceAnalysisStackedChart(options);
  };

  const setIsNavigateFromPerfAnalysis = (updated: boolean) => {
    updateIsNavigateFromPerfAnalysis(updated);
  };

  const setIsTimePeriodFirstLoad = (updated: boolean) => {
    updateIsTimePeriodFirstLoad(updated);
  };

  const setSortingOptionsProducts = (options: SortingOptionsType) => {
    updateSortOptionsProducts(options);
  };

  const setIsRetailerChanged = (options: boolean) => {
    updateIsRetailerChanged(options);
  };

  const setHitlistsClientId = (id: number) => {
    changeHitlistsClientId(id);
  };

  const setHitlistsClientSubscription = (subscription: OpaSubscription) => {
    changeHitlistsClientSubscription(subscription);
  };

  const setHitlistsClientCountries = (countryList: Country[]) => {
    changeHitlistsClientCountries(countryList);
  };

  const setRetailerKadClientId = (id: number) => {
    changeRetailKadClientId(id);
  };

  const setRetailKadClientSubscription = (sub: OpaSubscription) => {
    changeRetailKadClientSubscription(sub);
  };

  const setRetailKadClientCountries = (countries: Country[]) => {
    changeRetailKadClientCountries(countries);
  };

  const setMarketPremiumClientId = (id: number) => {
    changeMarketPremiumClientId(id);
  };

  const setMarketPremiumClientSubscription = (subscription: OpaSubscription) => {
    changeMarketPremiumClientSubscription(subscription);
  };

  const setMarketPremiumClientCountries = (countryList: Country[]) => {
    changeMarketPremiumClientCountries(countryList);
  };

  const setSellerInsightsClientId = (id: number) => {
    changeSellerInsightsClientId(id);
  };

  const setSellerInsightsClientSubscription = (subscription: OpaSubscription) => {
    changeSellerInsightsClientSubscription(subscription);
  };

  const setSellerInsightsClientCountries = (countryList: Country[]) => {
    changeSellerInsightsClientCountries(countryList);
  };

  const setProductGroupFeatureValueList = (pgFeatureValueList: ProductGroupFeatureValue[]) => {
    updateProductGroupFeatureValueList(pgFeatureValueList);
  };

  const setProductGroupPriceBandValueList = (productGroupPriceBandValue: ProductGroupPriceBandValue[]) => {
    updateProductGroupPriceBandValueList(productGroupPriceBandValue);
  };

  const setSavedFilterCountryList = (savedFilterCountries: string[]) => {
    updateSavedFilterCountryList(savedFilterCountries);
  };

  const setSavedFilterToShare = (savedFilter: SavedFilters) => {
    updateSavedFilterToShare(savedFilter);
  };

  const [sortingOptionsProducts, updateSortOptionsProducts] = useState<SortingOptionsType>( //NOSONAR typescript:S6754
    DefaultSortingOptionsForProducts,
  );

  const setIsMultiCountryDropdown = (multiCountryDropdown: boolean) => {
    updateIsMultiCountryDropdown(multiCountryDropdown);
  };

  const setMultiCountryClientCountries = (countryList: Option[]) => {
    changeMultiCountryClientCountries(countryList);
  };

  const setAccess = (accessObject: Object) => {
    changeAccess(accessObject);
  };

  const config: PagesConfig = {
    clientSubscription,
    setClientSubscription,
    clientId,
    setClientId,
    clientCountries,
    setClientCountries,
    userId,
    setUserId,
    pageType,
    setPageType,
    pageName,
    setPageName,
    getPageTypeAndName,
    selectedPgUpdated,
    setSelectedPgUpdated,
    filtersTrayOpened,
    toggleFiltersTray,
    selectedFilters,
    setSelectedFilters,
    appliedFilters,
    setAppliedFilters,
    pgsByPage,
    setPgsByPage,
    currencyExchangeRatePerCountry,
    updateCurrencyExchangeRatePerCountry,
    pgsByCountry,
    setPGsByCountry,
    pgsByAppliedCountry,
    setPGsByAppliedCountry,
    clearFilters,
    setClearFilters,
    applyFilters,
    setApplyFilters,
    addFeatures,
    setAddFeatures,
    segFeatures,
    setSegFeatures,
    sortingOptions,
    setSortingOptions,
    selectedTimeFrame,
    setSelectedTimeFrame,
    selectedTimePeriod,
    setSelectedTimePeriod,
    isNavigateFromCategoryLeaderboard,
    setNavigateFromCategoryLeaderboard,
    pgListUpdated,
    setPgListUpdated,
    savedFilters,
    setSavedFilters,
    isNavigateFromRS,
    setIsNavigateFromRS,
    isNavigateFromOpportunity,
    setIsNavigateFromOpportunity,
    isFirstVisit,
    setIsFirstVisit,
    isCountryChanged,
    setIsCountryChanged,
    isMultiCountryDropdown,
    setIsMultiCountryDropdown,
    sortingOptionsOpportunityReview,
    setSortingOptionsOpportunityReview,
    sortingOptionsPerformanceAnalysisStackedChart,
    setSortingOptionsPerformanceAnalysisStackedChart,
    isNavigateFromPerfAnalysis,
    setIsNavigateFromPerfAnalysis,
    isTimePeriodFirstLoad,
    setIsTimePeriodFirstLoad,
    sortingOptionsProducts,
    setSortingOptionsProducts,
    isRetailerChanged,
    setIsRetailerChanged,
    hitlistsClientSubscription,
    setHitlistsClientSubscription,
    hitlistsClientId,
    setHitlistsClientId,
    hitlistsClientCountries,
    setHitlistsClientCountries,
    productGroupFeatureValueList,
    setProductGroupFeatureValueList,
    productGroupPriceBandValueList,
    setProductGroupPriceBandValueList,
    savedFilterCountryList,
    setSavedFilterCountryList,
    savedFilterToShare,
    setSavedFilterToShare,
    retailKadClientSubscription,
    setRetailKadClientSubscription,
    retailKadClientId,
    setRetailKadClientId: setRetailerKadClientId,
    retailKadClientCountries,
    setRetailKadClientCountries,
    marketPremiumClientSubscription,
    setMarketPremiumClientSubscription,
    marketPremiumClientId,
    setMarketPremiumClientId,
    marketPremiumClientCountries,
    setMarketPremiumClientCountries,
    sellerInsightsClientSubscription,
    setSellerInsightsClientSubscription,
    sellerInsightsClientId,
    setSellerInsightsClientId,
    sellerInsightsClientCountries,
    setSellerInsightsClientCountries,
    sortByOptionsPerformanceAnalysisStackedChart,
    setSortByOptionsPerformanceAnalysisStackedChart,
    isMultiCountryFeatureFlagPA,
    setIsMultiCountryFeatureFlagPA: updateIsMultiCountryFeatureFlagPA,
    isSideFiltersFeatureFlagEnabled,
    setIsSideFiltersFeatureFlagEnabled: updateIsSideFiltersFeatureFlag,
    multiCountryClientCountries,
    setMultiCountryClientCountries,
    isClearAllFilterTriggered,
    setIsClearAllFilterTriggered,
    access,
    setAccess,
    isHidePGInfoWarning,
    setIsHidePGInfoWarning,
    masterPgsByCountry,
    setMasterPgsByCountry,
    isAllPgsByPeriodicityAvailable,
    setIsAllPgsByPeriodicityAvailable,
  };

  const initialState = useMemo(() => config, Object.values(config));

  return <PagesConfigContext.Provider value={initialState}>{children}</PagesConfigContext.Provider>;
};

export default PagesConfigProvider;
